<template>
  <v-dialog
    v-model="show"
    max-width="40vw"
    @click:outside="cancel"
  >
    <v-card
      flat
      class="pa-3 mt-2"
    >
      <v-card-title class="justify-center text-h5">
        {{ label }}
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          class="multi-col-validation mt-6"
        >
          <v-row>
            <v-col cols="12">
              <translation-fields
                v-model="translations"
                :fields="translatedFields"
              />
            </v-col>

            <v-col
              cols="12"
              md="6"
            >
              <v-select
                v-model="rkCurrencyId"
                :items="currencyDropDownId"
                :menu-props="{ maxHeight: '400' }"
                label="Валюта"
                dense
                :rules="[rules.required]"
                outlined
                persistent-hint
                :hint="currencyGuidHint"
              ></v-select>
            </v-col>

            <v-col
              cols="12"
              md="6"
            >
              <v-select
                v-model="type"
                :items="paymentMethodTypesDropDown"
                :menu-props="{ maxHeight: '400' }"
                label="Тип"
                dense
                :rules="[rules.required]"
                outlined
                persistent-hint
                hide-details
              ></v-select>
            </v-col>

            <v-col
              cols="12"
              md="6"
            >
              <v-select
                v-model="deliveryPaymentType"
                :items="deliveryPaymentTypesDropDown"
                :menu-props="{ maxHeight: '400' }"
                label="Тип оплаты в Delivery"
                hint="Не задан — заказ уйдёт как оплата наличными"
                clearable
                dense
                outlined
                persistent-hint
              ></v-select>
            </v-col>

            <v-col
              cols="12"
              md="6"
            >
              <v-select
                v-model="transferKind"
                :items="transferKindsDropDown"
                :menu-props="{ maxHeight: '400' }"
                label="Чем платят при переводе"
                hint="Показывается только там, где у заведения заведён нужный токен Bakai"
                clearable
                dense
                outlined
                persistent-hint
              ></v-select>
            </v-col>

            <v-col
              cols="12"
              md="6"
            >
              <v-select
                v-model="rkReasonId"
                :items="reasonsDropDown"
                :menu-props="{ maxHeight: '400' }"
                label="Причина"
                dense
                :rules="[rules.required]"
                outlined
                persistent-hint
                hide-details
              ></v-select>
            </v-col>

            <v-col
              md="6"
              cols="12"
            >
              <v-textarea
                v-model="icon"
                label="Иконка"
                dense
                outlined
              ></v-textarea>
            </v-col>

            <v-col
              md="6"
              cols="12"
            >
              <v-checkbox
                v-model="isCashRequired"
                label="Обязателен ввод суммы"
                dense
                outlined
              ></v-checkbox>
            </v-col>

            <v-col
              md="6"
              cols="12"
            >
              <v-switch
                v-model="isActive"
                label="Активен"
                dense
                inset
                hint="Выключенный способ не виден ни на сайте, ни в приложении и не принимается при оформлении"
                persistent-hint
              ></v-switch>
            </v-col>

            <v-col
              md="6"
              cols="12"
            >
              <v-select
                v-model="applicationTypes"
                :items="applicationTypesDropdown"
                :menu-props="{ maxHeight: '400' }"
                label="Где показывать способ"
                multiple
                dense
                hint="Пусто — способ не показывается нигде: ни на сайте, ни в приложении"
                persistent-hint
                outlined
              ></v-select>
            </v-col>

            <v-col cols="12">
              <v-btn
                color="primary"
                class="me-3 mt-4"
                @click="saveData"
              >
                Сохранить
              </v-btn>
              <v-btn
                color="secondary"
                outlined
                class="mt-4"
                type="reset"
                @click="cancel"
              >
                Отмена
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mdiCheck, mdiClose } from '@mdi/js'
import { mapActions, mapGetters } from 'vuex'
import { mapFormHandlers } from '@/helpers/forms'
import { rules } from '@/helpers/validation'
import TranslationFields from '@/components/translation-fields'

export default {
  name: 'PaymentMethodForm',
  components: { TranslationFields },
  props: ['save', 'show', 'cancellation', 'label'],
  data: () => ({
    icons: {
      mdiCheck,
      mdiClose,
    },
    rules,
    translatedFields: [
      { key: 'name', label: 'Наименование', required: true },
      { key: 'description', label: 'Описание', multiline: true },
    ],
  }),
  computed: {
    ...mapFormHandlers('paymentMethod/form', [
      'rkCurrencyId',
      'rkCurrencyGuid',
      'translations',
      'type',
      'deliveryPaymentType',
      'transferKind',
      'rkReasonId',
      'isCashRequired',
      'isActive',
      'applicationTypes',
      'icon',
    ]),

    currencyGuidHint() {
      return this.rkCurrencyGuid
        ? `GUID валюты: ${this.rkCurrencyGuid}`
        : 'GUID валюты не заполнен — оплата не уйдёт в Delivery. Сохраните способ, чтобы он проставился.'
    },
    ...mapGetters('dictionary', { reasonsDropDown: 'rk7ReasonsDropDown' }),
    ...mapGetters('dictionary', { applicationTypesDropdown: 'applicationTypesDropdown' }),
    ...mapGetters('dictionary', { currencyDropDownId: 'currencyDropDownId' }),
    ...mapGetters('dictionary', {
      paymentMethodTypesDropDown: 'paymentMethodTypesDropDown',
      deliveryPaymentTypesDropDown: 'deliveryPaymentTypesDropDown',
      transferKindsDropDown: 'transferKindsDropDown',
    }),
  },
  watch: {
    rkCurrencyId(value) {
      const currency = this.$store.state.dictionary.currencies.find(x => x.id === value)
      if (currency) {
        this.rkCurrencyGuid = currency.guid
      }
    },

    show(newValue) {
      if (newValue && this.$refs.form) {
        this.$refs.form.resetValidation()
      }
    },
  },
  async mounted() {
    await this.fetchCurrencies()
    await this.fetchReasons()
    await this.fetchPaymentMethodTypes()
    await this.fetchDeliveryPaymentTypes()
    await this.fetchApplicationTypes()
    await this.fetchTransferKinds()
  },
  methods: {
    cancel() {
      this.resetForm()
      this.cancellation()
    },
    ...mapActions('dictionary', {
      fetchReasons: 'fetchRk7Reasons',
      fetchCurrencies: 'fetchCurrencies',
      fetchPaymentMethodTypes: 'fetchPaymentMethodTypes',
      fetchDeliveryPaymentTypes: 'fetchDeliveryPaymentTypes',
      fetchApplicationTypes: 'fetchApplicationTypes',
      fetchTransferKinds: 'fetchTransferKinds',
    }),
    ...mapActions('paymentMethod/form', ['resetForm']),
    async saveData() {
      if (this.$refs.form.validate()) {
        await this.save()
        this.resetForm()
      }
    },
  },
}
</script>
